module.exports = __webpack_public_path__ + "img/footer-1-5.b19b24cd.png";